import { SSMService } from 'src/services/aws/SSMService';
import { ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';

/**
 * private static readonly AppSyncEventsEndpointStoreKey = '/das-finsuite/fe/eventsApiEndpoint_annunna';
 * private static readonly AppSyncGraphQLEndpointStoreKey = '/das-finsuite/fe/graphQLEndpoint_annunna';
 */
export class AppSyncService {
  // If you are connecting to personal stack backend, add _{USER} at the end
  private static readonly AppSyncEventsEndpointStoreKey = '/das-finsuite/fe/eventsApiEndpoint';
  private static readonly AppSyncGraphQLEndpointStoreKey = '/das-finsuite/fe/graphQLEndpoint';

  private static async retrieveEndpoint(storeKey: string, endpointType: string): Promise<string> {
    const { Stage } = ENVIRONMENT_VARIABLES.env;
    const api_stage = Stage === 'dev' ? 'alpha' : Stage;
    const endpoint = await SSMService.retrieveParameter(`${storeKey}-${api_stage}`);

    if (endpoint) {
      console.log(`AppSync ${endpointType} Endpoint retrieved successfully!`, { logType: 'configStatus' });
      return endpoint;
    } else {
      console.error(`AppSync ${endpointType} Endpoint retrieval failed!`, { logType: 'configStatus' });
      throw new Error(`Failed to retrieve AppSync ${endpointType} Endpoint from parameter: ${storeKey}-${api_stage}`);
    }
  }

  public static async getAppSyncEventsEndpoint(): Promise<string> {
    return this.retrieveEndpoint(this.AppSyncEventsEndpointStoreKey, 'Events');
  }

  public static async getAppSyncGraphQLEndpoint(): Promise<string> {
    return this.retrieveEndpoint(this.AppSyncGraphQLEndpointStoreKey, 'GraphQL');
  }
}
